import { Category, Product, Stage, Cycle } from '.';

export enum PathMode {
  NONE = 0,
  PRODUCT = 1,
  SESSION = 2,
  CYCLE = 3
}
export enum PathName {
  NONE,
  CATALOG,
  CATEGORY,
  PRODUCT,
  STAGE,
  CYCLE
}
export class PathItem {
  public Key: PathName;
  public Ident: string;
  public Value: string;
  constructor(key: PathName, id: string, value: any) {
    this.Key = key;
    this.Ident = id;
    this.Value = JSON.stringify(value);
  }
}
//export class PathItem<T> {
//  public Key: PathName;
//  public Value: T;
//  constructor() { }
//}


export class PathModel {
  private _pathList: PathItem[];

  //////private _pathMode: PathMode;
  //////get PathMode(): PathMode { return this._pathMode; }
  //////set bar(value: PathMode) { this._pathMode = value; }


  constructor() {
    //////this._pathMode = PathMode.NONE;
    this._pathList = [];
  }


  SetPathItem(key: PathName, id: string, value: any): void {
    this._pathList.push(new PathItem(key, id, value));
  }

  private getPathItem<T>(key: PathName, id: string): T | null {
    const r: PathItem[] = this._pathList.filter((e: PathItem) => e.Key === key && e.Ident === id);
    if (r && r.length > 0) {
      const obj: T = JSON.parse(r[0].Value);
      return obj;
      //return JSON.parse(r[0].Value) as T;
    }
    return null;
  }

  //getRespProduct(): string {
  //  let result: string = '';
  //  const r1: Category | null = this.getPathItem<Category>(PathName.CATEGORY);
  //  const r2: Product | null = this.getPathItem<Product>(PathName.PRODUCT);
  //  result = r1 && r1.User_CAT ? r1.User_CAT : '';
  //  result = (r2 && r2.Responsable && r2.Responsable.Ident !== '' && r2.Responsable.Ident !== '0') ? r2.Responsable.Ident : result;
  //  return result;
  //}

  //getRespStage(): string {
  //  let result: string = '';
  //  const r1: Stage | null = this.getPathItem<Stage>(PathName.STAGE);
  //  result = r1 && r1.ResponsablesList && r1.ResponsablesList.length > 0 ? r1.ResponsablesList[0].Ident : '';
  //  return result;
  //}

  //getRespCycle(): string {
  //  let result: string = '';
  //  const r1: Cycle | null = this.getPathItem<Cycle>(PathName.CYCLE);
  //  result = r1 && r1.ResponsableCycle && r1.ResponsableCycle.Ident !== '' && r1.ResponsableCycle.Ident !== '0' ? r1.ResponsableCycle.Ident : '';
  //  return result;
  //}

  hasResponsable(modo: PathMode, id: string): boolean {
    let result: string = '';
    switch (modo) {
      case PathMode.PRODUCT:
        const rA: Category | null = this.getPathItem<Category>(PathName.CATEGORY, id);
        const rB: Product | null = this.getPathItem<Product>(PathName.PRODUCT, id);
        result = (rB && rB.Responsable && rB.Responsable.Ident !== '' && rB.Responsable.Ident !== '0') ? rB.Responsable.Ident : '';
        if (result === '' && rA && rB && rB.ParentCategory) {
          const r3: Category | null = this.getPathItem<Category>(PathName.CATEGORY, rB.ParentCategory.Ident);
          result = r3 && r3.User_CAT ? r3.User_CAT : '';
        }
        break;

      case PathMode.SESSION:

        const r1: Stage | null = this.getPathItem<Stage>(PathName.STAGE, id);
        result = r1 && r1.ResponsablesList && r1.ResponsablesList.length > 0 ? r1.ResponsablesList[0].Ident : '';
        if (result === '' && r1 && r1.ParentProduct) {
          const r2: Product | null = this.getPathItem<Product>(PathName.PRODUCT, r1.ParentProduct.Ident);
          result = (r2 && r2.Responsable && r2.Responsable.Ident !== '' && r2.Responsable.Ident !== '0') ? r2.Responsable.Ident : '';
          if (result === '' && r2 && r2.ParentCategory) {
            const r3: Category | null = this.getPathItem<Category>(PathName.CATEGORY, r2.ParentCategory.Ident);
            result = r3 && r3.User_CAT ? r3.User_CAT : '';
          }
          if (result === '' && r2 && r2.IdCategoriePere !== '' && r2.IdCategoriePere !== '0') {
            const r4: Category | null = this.getPathItem<Category>(PathName.CATEGORY, r2.IdCategoriePere);
            result = r4 && r4.User_CAT ? r4.User_CAT : '';
          }
        }
        break;
      case PathMode.CYCLE:
        const r5: Cycle | null = this.getPathItem<Cycle>(PathName.CYCLE, id);
        result = r5 && r5.ResponsableCycle && r5.ResponsableCycle.Ident !== '' && r5.ResponsableCycle.Ident !== '0' ? r5.ResponsableCycle.Ident : '';
        break;
    }
    return result !== '';
  }

}
